export default __webpack_public_path__ + "static/media/serproError.51877193.gif";